import React from 'react';
import { Link } from 'react-router-dom';
import { useHoverPreload } from '../hooks/useRoutePreloader';
import { getRouteNameFromPath } from '../utils/routePreloader';

/**
 * Enhanced Link component with route preloading on hover
 * Drop-in replacement for React Router's Link component
 */
const PreloadLink = ({ to, children, className, ...props }) => {
  // Get route name from path
  const routeName = getRouteNameFromPath(to);

  // Get hover preload handlers
  const hoverPreloadProps = useHoverPreload(routeName);

  // Only apply preload handlers if we have a valid route name
  const linkProps = routeName ? hoverPreloadProps : {};

  return (
    <Link to={to} className={className} {...linkProps} {...props}>
      {children}
    </Link>
  );
};

export default PreloadLink;
